import { api } from './client';
import type { ImportantNotice } from '../features/notices/types';
export type { ImportantNotice } from '../features/notices/types';

const API_BASE = process.env.REACT_APP_API_URL ?? '';

function getBase(): string {
  return (API_BASE || '').replace(/\/$/, '');
}

/** URL for displaying a notice image by id. Use for img src. */
export function getNoticeFileUrl(id: string | null | undefined): string {
  if (!id) return '';
  const base = getBase();
  const path = `/api/notices/file/${id}`;
  return base ? `${base}${path}` : path;
}

export async function getPublicNotices(): Promise<ImportantNotice[]> {
  return api.get<ImportantNotice[]>('/api/notices/public');
}

export async function getNotices(): Promise<ImportantNotice[]> {
  return api.get<ImportantNotice[]>('/api/notices');
}

export async function createNotice(formData: FormData): Promise<ImportantNotice> {
  return api.postForm<ImportantNotice>('/api/notices', formData);
}

export async function updateNotice(
  id: string,
  body: { title?: string; description?: string | null; descriptionHtml?: string | null }
): Promise<ImportantNotice> {
  return api.patch<ImportantNotice>(`/api/notices/${id}`, body);
}

export async function reorderNotices(ids: string[]): Promise<void> {
  await api.put<void>('/api/notices/reorder', { ids });
}

export async function deleteNotice(id: string): Promise<void> {
  return api.delete(`/api/notices/${id}`);
}
